import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { ReportFilterService } from '@app/core/services/report-filter.service';
import { POPOVER_DATA, PopoverRef } from '@app/shared/modules/template/components/popover';

@Component({
  templateUrl: './popover-report-filter.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PopoverReportFilterComponent {
  constructor(
    @Inject(POPOVER_DATA) public data: any,
    public popoverRef: PopoverRef<string>,
    public reportFilterService: ReportFilterService,
  ) {}

  public passfilterType(filterType: number) {
    this.reportFilterService.passfilterType(filterType);
    this.popoverRef.close(true);
  }
}
